import { Expose } from 'class-transformer';
import { NetworkResourceType } from '../util/network-resource-type';

export class SnvrNetworkResource {

    @Expose({name: 'resource_id'})
    resourceId: number;

    @Expose()
    error: boolean;

    @Expose()
    name: string;

    @Expose()
    address: string;

    @Expose()
    port: number;

    @Expose()
    type: NetworkResourceType;

    @Expose({ name: 'login_name' })
    loginName: string;

    @Expose()
    password: string;

    @Expose({ name: 'free_disk_space' })
    freeDiskSpace: number;

    @Expose({ name: 'disk_space_used' })
    diskSpaceUsed: number;

}
